import { create } from 'zustand'
import type { Modality, ScanStatus, AssetType, SourceType } from '@/api/types'

interface SourceFilters {
  search: string
  modality: Modality | ''
  source_type: SourceType | ''
  is_active: 'all' | 'true' | 'false'
}

interface ScanFilters {
  status: ScanStatus | ''
  source_id: string
}

interface AssetFilters {
  modality: Modality | ''
  asset_type: AssetType | ''
  is_quantum_safe: 'all' | 'true' | 'false'
  source_id: string
}

interface DiscoveryState {
  sourceFilters: SourceFilters
  scanFilters: ScanFilters
  assetFilters: AssetFilters
  setSourceFilters: (f: Partial<SourceFilters>) => void
  setScanFilters: (f: Partial<ScanFilters>) => void
  setAssetFilters: (f: Partial<AssetFilters>) => void
  resetSourceFilters: () => void
  resetScanFilters: () => void
  resetAssetFilters: () => void
}

const defaultSourceFilters: SourceFilters = {
  search: '',
  modality: '',
  source_type: '',
  is_active: 'all',
}

const defaultScanFilters: ScanFilters = {
  status: '',
  source_id: '',
}

const defaultAssetFilters: AssetFilters = {
  modality: '',
  asset_type: '',
  is_quantum_safe: 'all',
  source_id: '',
}

export const useDiscoveryStore = create<DiscoveryState>((set) => ({
  sourceFilters: defaultSourceFilters,
  scanFilters: defaultScanFilters,
  assetFilters: defaultAssetFilters,

  setSourceFilters: (f) =>
    set((state) => ({ sourceFilters: { ...state.sourceFilters, ...f } })),
  setScanFilters: (f) =>
    set((state) => ({ scanFilters: { ...state.scanFilters, ...f } })),
  setAssetFilters: (f) =>
    set((state) => ({ assetFilters: { ...state.assetFilters, ...f } })),

  resetSourceFilters: () => set({ sourceFilters: defaultSourceFilters }),
  resetScanFilters: () => set({ scanFilters: defaultScanFilters }),
  resetAssetFilters: () => set({ assetFilters: defaultAssetFilters }),
}))
